import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'
import parserFilters from '@/utils/parserFilters'
import parserSlug from '@/utils/parserSlug'

Vue.use(Vuex)

const getDefaultState = () => {
  return {
    details: []
  }
}

const state = {
  purchaseRequisition: {},
  inventories: [],
  units_measurement: [],
  users: [],
  details: [],
  pagination: {
    currentPage: 1,
    perPage: 5,
    totalInventories: 0,
    totalPages: 0
  },
  inventoriesCatalog: {},
  filterParams: '',
  isModalVisible: false,
  isModalImportRestrictionsVisible: false,
  isModalContactVisible: false
}

const mutations = {
  SET_INVENTORYS (state, payload) {
    state.inventories = payload.data

    state.pagination = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      totalInventories: payload.total,
      totalPages: payload.last_page
    }
  },
  ADD_PURCHASE_REQUISITION_DETAIL (state, payload) {
    payload.original_total = payload.total
    if (payload.hasDiscount === 1) {
      payload.total = payload.discount_total
    }
    if (state.details.length > 0) {
      let detail = state.details.find(e => parseInt(e.inventory_id) === parseInt(payload.inventory_id))

      if (detail) {
        detail.quantity = detail.quantity + payload.quantity
        detail.hasDiscount = payload.hasDiscount
        detail.total = detail.total + payload.total
        detail.original_total = parseFloat(detail.quantity) * detail.unit_price
        if (payload.hasDiscount === 1) {
          detail.total = parseFloat(detail.quantity) * detail.discount_price
        }
      } else {
        state.details.push(payload)
      }
    } else {
      return state.details.push(payload)
    }
  },
  SET_MODAL_VISIBLE (state, payload) {
    state.isModalVisible = payload
  },
  SET_MODAL_IMPORT_RESTRICTIONS_VISIBLE (state, payload) {
    state.isModalImportRestrictionsVisible = payload
  },
  SET_MODAL_CONTACT_VISIBLE (state, payload) {
    state.isModalContactVisible = payload
  },
  SET_FILTER_PARAMS (state, payload) {
    state.filterParams = payload
  },
  SET_CATALOG (state, { object, payload }) {
    state.inventoriesCatalog[object] = payload.data
  },
  CLEAR_DETAIL () {
    state.details = []
  },
  UPDATE_PURCHASE_REQUISITION (state, payload) {
    state.purchaseRequisition = payload
  },
  DELETE_PURCHASE_REQUISITION_DETAIL (state, idx) {
    if (idx >= 0) {
      Vue.delete(state.details, idx)
    }
  },
  UPDATE_PURCHASE_REQUISITION_ACTION (state, payload) {
    const idx = state.purchaseRequisitions.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.set(state.purchaseRequisitions, idx, payload)
    }
  },
  UPDATE_INVENTORY_RESTRICTIONS (state, payload) {
    state.inventories.map(e => {
      payload.data.find(item => {
        item.id === e.id && (e.discount_quantity = item.discount_quantity)
      })
    })
  },
  UPDATE_ORDER_TOTAL (state, payload) {

  },
  RESET_STATE (state) {
    Object.assign(state, getDefaultState())
  }
}
const actions = {
  resetState ({ commit }) {
    commit('RESET_STATE', null, { root: true })
  },
  async adjustTotal ({ commit }, payload) {
    commit('UPDATE_ORDER_TOTAL', payload)
  },
  async downloadRestrictionsTemplate ({ commit }, payload) {
    app.$Progress.start()
    let url = parserSlug(payload.model)
    try {
      window.open(`${Vue.axios.defaults.baseURL}/${url}/restrictions-template`)
    } catch (error) {
      app.$Progress.fail()
    } finally {
      app.$Progress.finish()
    }
  },
  async importDataRestrictions ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.post(`inventories/import-restrictions`, payload)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.purchase_requisitions', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.purchase_requisitions', text: 'front.sent_successfully', icon: 'checkmark-circle-outline' }, { root: true })
        commit('UPDATE_INVENTORY_RESTRICTIONS', response.data)
        commit('SET_MODAL_IMPORT_RESTRICTIONS_VISIBLE', false)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async sendContactEmail ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.post(`purchase-requisitions/${payload.detail.inventory_id}/send-contact`, payload.detail)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.purchase_requisitions', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.purchase_requisitions', text: 'front.sent_successfully', icon: 'checkmark-circle-outline' }, { root: true })
        commit('SET_MODAL_CONTACT_VISIBLE', false)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async addPurchaseRequisition ({ commit }, payload) {
    const purchaseRequisition = {
      amount: parseFloat(payload.amount),
      og_total: parseFloat(payload.og_total),
      details: payload.details
    }
    app.$Progress.start()

    try {
      const response = await axios.post('purchase-requisitions', purchaseRequisition)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.purchase_requisitions', text: checkErrors.message }, { root: true })
      } else {
        commit('CLEAR_DETAIL', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.purchase_requisitions', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async editPurchaseRequisition ({ commit }, payload) {
    const purchaseRequisition = {
      amount: parseFloat(payload.amount),
      details: payload.details
    }
    app.$Progress.start()

    try {
      const response = await axios.put(`purchase-requisitions/${payload.id}`, purchaseRequisition)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.purchase_Requisitions', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_PURCHASE_REQUISITION', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.purchase_Requisitions', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deletePurchaseRequisition ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`purchase-requisitions/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.purchase_requisitions', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_PURCHASE_REQUISITION', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.purchase_requisitions', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deletePurchaseRequisitions ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`purchase-requisitions/delete`, { params: { ids: payload.ids } })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.purchase_requisitions', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_PURCHASE_REQUISITIONS', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.purchase_requisitions', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadInventories ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`inventories?page=${payload.page}${state.filterParams}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_INVENTORYS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async addPurchaseRequisitionDetail ({ commit }, payload) {
    app.$Progress.start()
    const PurchaseRequisitionDetail = {
      inventory_id: payload.inventory_id,
      sku: payload.sku,
      product: payload.product,
      original_total: payload.original_total,
      quantity: parseFloat(payload.quantity),
      discount_quantity: parseFloat(payload.discount_quantity),
      unit_price: parseFloat(payload.unit_price),
      discount_price: parseFloat(payload.discount_price),
      unit_measurement: payload.unit_measurement,
      total: parseFloat(payload.total),
      discount_total: parseFloat(payload.discount_total),
      hasDiscount: parseInt(payload.hasDiscount)
    }
    commit('ADD_PURCHASE_REQUISITION_DETAIL', PurchaseRequisitionDetail)
    commit('SET_MODAL_VISIBLE', false)
    app.$Progress.finish()
  },
  async editPurchaseRequisitionDetail ({ commit }, payload) {
    app.$Progress.start()
    const PurchaseRequisitionDetail = {
      id: payload.detail.id,
      product: payload.product,
      quantity: parseFloat(payload.quantity),
      unit_price: parseFloat(payload.unit_price),
      unit_measurement: payload.unit_measurement,
      inventory_id: payload.inventory_id,
      total: parseFloat(payload.total)
    }
    commit('UPDATE_PURCHASE_REQUISITION_DETAIL', { payload: PurchaseRequisitionDetail, idx: payload.index })
    commit('SET_MODAL_VISIBLE', false)
    app.$Progress.finish()
  },
  async deletePurchaseRequisitionDetail ({ commit }, payload) {
    app.$Progress.start()
    commit('DELETE_PURCHASE_REQUISITION_DETAIL', payload.index)
    app.$Progress.finish()
  },
  async actionInventory ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.put(`inventories/${payload.id}/${payload.action}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_INVENTORY', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.inventories', text: `inventories.${payload.action}`, icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  applyFilter ({ commit }, payload) {
    const filter = parserFilters(payload)
    commit('SET_FILTER_PARAMS', filter)
  },
  clearFilter ({ commit }, payload) {
    const filter = ''
    commit('SET_FILTER_PARAMS', filter)
  },
  async loadCatalog ({ commit }, payload) {
    let url = parserSlug(payload.url)
    app.$Progress.start()
    try {
      const response = await axios.get(`${url}${payload.filter}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CATALOG', { object: payload.url, payload: response.data })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  setModalVisible ({ commit }, payload) {
    commit('SET_MODAL_VISIBLE', payload)
  },
  setModalImportRestrictionsVisible ({ commit }, payload) {
    commit('SET_MODAL_IMPORT_RESTRICTIONS_VISIBLE', payload)
  },
  setModalContactVisible ({ commit }, payload) {
    commit('SET_MODAL_CONTACT_VISIBLE', payload)
  },
  setModalImportVisible ({ commit }, payload) {
    commit('SET_MODAL_IMPORT_VISIBLE', payload, { root: true })
  }
}

const getters = {
  details: state => state.details,
  inventories: state => state.inventories,
  inventoriesCatalog: state => state.inventoriesCatalog,
  pagination: state => state.pagination,
  isModalVisible: state => state.isModalVisible,
  isModalContactVisible: state => state.isModalContactVisible,
  isModalImportRestrictionsVisible: state => state.isModalImportRestrictionsVisible,
  filterParams: state => state.filterParams
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
